import {useSearchParams} from "react-router-dom";

export default function useQueryParams() {
  return useSearchParams()[0];
}
